import { render } from "./AnalyticsDiamondCompletion.vue?vue&type=template&id=4b20cb5c&scoped=true"
import script from "./AnalyticsDiamondCompletion.vue?vue&type=script&lang=js"
export * from "./AnalyticsDiamondCompletion.vue?vue&type=script&lang=js"

import "@/css/components/analytics-diamond-completion.css?vue&type=style&index=0&id=4b20cb5c&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b20cb5c"]])

export default __exports__